

















import { defineComponent } from '~/utils/nuxt3-migration'
import AccountService from '~/services/account/AccountService'
import { mapDeps } from '~/plugins/dependency-container/utils'

export default defineComponent({
  data() {
    return {}
  },
  computed: {
    ...mapDeps({
      accountService: AccountService
    })
  }
})
